import React from 'react';

export default function UserList({ users, onEdit, onDelete, isSCUser, currentPage, totalPages, onPageChange }) {
  function handleEdit(idx, e) {
    if (!isSCUser) {
      e.preventDefault();
      alert('Only SC Users are allowed!');
      return;
    }
    onEdit(idx, e);
  }

  function handleDelete(idx, e) {
    if (!isSCUser) {
      e.preventDefault();
      alert('Only SC Users are allowed!');
      return;
    }
    if (!window.confirm('Are you sure you want to delete this user?')) {
      e.preventDefault();
      return;
    }
    onDelete(idx, e);
  }

  return (
    <div className="table-container no-shadow" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
  <h2 style={{ textAlign: 'left', minWidth: 720, marginLeft: 0, marginBottom: '2.0rem' }}>SC User List</h2>
      {/* <div style={{ textAlign: 'left', minWidth: 720, marginLeft: 0, marginBottom: '1rem' }}>
        <h2>SC User List</h2>
      </div> */}
      <table style={{ width: 'auto', minWidth: 720, margin: '0 auto', tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr><td colSpan="3">No users found.</td></tr>
          ) : (
            users.map((user, idx) => (
              <tr key={idx}>
                <td style={{ whiteSpace: 'nowrap' }}>{user.name}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{user.email}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <button onClick={e => handleEdit(idx, e)} style={{ marginRight: 8 }}>Edit</button>
                  <button onClick={e => handleDelete(idx, e)}>Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div style={{ width: 'auto', minWidth: 720, display: 'flex', justifyContent: 'flex-end', marginTop: '1rem', gap: '0.5rem' }}>
        <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>Prev</button>
        <span style={{ alignSelf: 'center' }}>Page {currentPage} of {totalPages}</span>
        <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
      </div>
    </div>
  );
}
